// types
import { i18nCalendar } from 'models/i18n';

// ==============================|| I18N EN DELIVERY POINTS ||============================== //

const enCalendar: i18nCalendar = {
  createEventTitle: 'Create event',
  title: 'Operation calendar',
  availablePowerForTitle: ' : Available power ',
  titleForContract: ' : Contract Fulfillment ',
  toolbar: {
    todayButton: 'Today',
    viewOptions: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      agenda: 'Agenda'
    },
    deviceGroup: 'Devices',
    deliveryPointGroup: 'Delivery points',
    balanceGroupsGroup: 'Balance Groups',
    showAll: 'Show All Events'
  },
  eventDialog: {
    input: {
      name: 'Event name',
      type: 'Event type',
      deviceId: 'Device Name',
      DeviceOffline: 'Device offline',
      availablePower: 'Available power',
      description: 'Event description',
      deliveryContractId: 'Contract',
      AddButton: 'Add Event',
      EditButton: 'Edit Event',
      ChooseTime: 'Choose date and time',
      invalidateButton: 'Invalidate event'
    },
    meta: {
      createdBy: 'Created By:',
      updatedBy: 'Updated By:'
    },
    validation: {
      'name-required': 'Event name is required',
      'name-max': 'Maximum length exceeded',
      'type-required': 'Event type is required',
      'deviceId-required': 'Device name is required',
      'description-max': 'Maximum length exceeded',
      'deliveryContractId-required': 'Contract is required',
      'availablePower-required': 'Power is required',
      'availablePower-number': 'Power must be number'
    },
    AllDay: 'All day',
    NoEvents: 'No events',
    CreateEventTitle: 'Create event',
    UpdateEventTitle: 'Update event',
    DeviceOffline: 'Device offline',
    AvailablePower: 'Available power',
    StartDate: 'Start',
    EndDate: 'End',
    EventDescription: 'Description',
    DeleteButton: 'Delete',
    InvalidateButton: 'Invalidate',
    CreateEventButton: 'Create event',
    SHUTDOWN: 'ShutDown',
    MAINTENANCE: 'Maintenance',
    MALFUNCTION: 'Malfunction',
    CONTRACT: 'Contract',
    ErrorStartInPast: 'Start time has to be in future',
    ErrorEndInPast: 'End time has to be in future',
    ErrorStartTimeMessage: 'Start time is after end time',
    ErrorEndTimeMessage: 'End time is before start time',
    ContractWithoutName: 'No name'
  },
  activityLog: {
    title: 'Activity log'
  },
  input: {
    Filter: ''
  }
};

export default enCalendar;
